import { useResolution886Report } from '@/context/Resolution886Report';

interface Video {
	id: string;
	original_name: string;
	generated_name: string;
	created_at: string;
}

export function useGetSelectedVideos(): Video[] {
	const { assessment } = useResolution886Report();

	if (!assessment || !assessment.file) {
		return [];
	}

	const videos: Video[] = [
		{
			id: assessment.file.id,
			original_name: assessment.file.original_name,
			generated_name: assessment.file.generated_name,
			created_at: assessment.created_at
		}
	];

	return videos;
}
